import { useEffect } from "react";
import { useSearchParams, useMatch, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { successLogin } from "../redux/reducers/AuthSlice";
export const useVerifyEmail = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isEmailVerifyUrl = useMatch("/verify-email");
	const [searchParams] = useSearchParams();
	const url = searchParams.get("url");

	useEffect(() => {
		if (isEmailVerifyUrl && url) {
			verifyEmail(url);
		}
	}, [isEmailVerifyUrl, url]);

	const verifyEmail = () => {
		axios
			.get(url)
			.then((res) => {
				dispatch(successLogin(res.data.data));
				navigate("/onboarding");
			})
			.catch((err) => {
				toast.error(err.response.data.message);
			});
	};
};
